import api from "api";

const menu = {
    // Public
    getPublicMenu: (slug) =>
        api(null, true).get(`/establishments/${slug}/menu`),
    getMenu: (slug) =>
        api().get(`/establishments/${slug}/menu`),

    // Categories
    getCategories: (slug) =>
        api().get(`/establishments/${slug}/menu/categories`),
    createCategory: (slug, payload) =>
        api().post(`/establishments/${slug}/menu/categories`, payload),
    updateCategory: (slug, id, payload) =>
        api().put(`/establishments/${slug}/menu/categories/${id}`, payload),
    deleteCategory: (slug, id) =>
        api().delete(`/establishments/${slug}/menu/categories/${id}`),

    // Products
    getProducts: (slug, params = {}) =>
        api().get(`/establishments/${slug}/menu/products`, { params }),
    getProduct: (slug, id) =>
        api().get(`/establishments/${slug}/menu/products/${id}`),
    createProduct: (slug, payload) =>
        api().post(`/establishments/${slug}/menu/products`, payload),
    updateProduct: (slug, id, payload) =>
        api().put(`/establishments/${slug}/menu/products/${id}`, payload),
    deleteProduct: (slug, id) =>
        api().delete(`/establishments/${slug}/menu/products/${id}`),
    syncOptionGroups: (slug, id, optionGroupIds) =>
        api().put(`/establishments/${slug}/menu/products/${id}/option-groups`, {
            option_group_ids: optionGroupIds
        }),

    // Option Groups
    getOptionGroups: (slug) =>
        api().get(`/establishments/${slug}/menu/option-groups`),
    createOptionGroup: (slug, payload) =>
        api().post(`/establishments/${slug}/menu/option-groups`, payload),
    updateOptionGroup: (slug, id, payload) =>
        api().put(`/establishments/${slug}/menu/option-groups/${id}`, payload),
    deleteOptionGroup: (slug, id) =>
        api().delete(`/establishments/${slug}/menu/option-groups/${id}`),

    // Options
    createOption: (slug, groupId, payload) =>
        api().post(`/establishments/${slug}/menu/option-groups/${groupId}/options`, payload),
    updateOption: (id, payload) =>
        api().put(`/menu/options/${id}`, payload),
    deleteOption: (id) =>
        api().delete(`/menu/options/${id}`),
};

export default menu;
